export type Category = "DeFi" | "TradFi" | "Regulatory" | "Uncategorized";

const REGULATORY = [/\bfine[ds]?\b/i, /\bsec\b/i, /\bcftc\b/i, /\bregulat/i, /\bsanction/i];
const DEFI = [/aave/i, /uniswap/i, /lido/i, /\btvl\b/i, /\bdefi\b/i, /protocol fees?/i, /staking/i];
const TRADFI = [/jpmorgan/i, /goldman/i, /citigroup/i, /tesla/i, /earnings/i, /\beps\b/i, /revenue/i, /net income/i];

export function categorize(question: string): Category {
  if (REGULATORY.some((r) => r.test(question))) return "Regulatory";
  if (DEFI.some((r) => r.test(question))) return "DeFi";
  if (TRADFI.some((r) => r.test(question))) return "TradFi";
  return "Uncategorized";
}

// Excludes "Uncategorized" — not a user-selectable filter
export const CATEGORIES: Category[] = ["DeFi", "TradFi", "Regulatory"];
